export const appAdd2CartWidget = {
    create: function(){
        var that = this;
        if($('.js-add2cart-widget').length){
            that.bindEvents();
        }
    },
    bindEvents: function(){
        var that = this;
        $(document).on('click', '.js-corqaunt-up', function(e){
            var widget = $(this).closest('.js-add2cart-widget'),
                numField = $(widget).find('.js-add2cart-number');
            $(numField)[0].stepUp();
        });
        $(document).on('click', '.js-corqaunt-down', function(e){
            var widget = $(this).closest('.js-add2cart-widget'),
                numField = $(widget).find('.js-add2cart-number');
            $(numField)[0].stepDown();
        });
    }
};